import { useBrPageContext } from "../../context/context/context.js";
import { getProductCategories } from "../../utils/utils/get-product-categories.js";
const useBloomreachSdpContent = () => {
  const page = useBrPageContext();
  const models = page?.getComponent("main")?.getModels();
  const storeDocument = models?.storeDetailDocument;
  if (!page || !storeDocument) {
    return {};
  }
  const content = page?.getContent(storeDocument)?.getData();
  if (!content) {
    console.warn(
      `Cannot find main content for StoreDetailPage pageModel. Got: ${content} for $ref: ${storeDocument}`
    );
    return {};
  }
  const storeDetailCampaignRef = content?.storeDetailCampaign?.image;
  const campaignBannerContent = storeDetailCampaignRef ? page.getContent(storeDetailCampaignRef) : void 0;
  const campaignBanner = campaignBannerContent && {
    description: campaignBannerContent.getDescription(),
    url: campaignBannerContent.getOriginal()?.getUrl()
  };
  const productCategories = getProductCategories(content?.productCategoriesCompound, page);
  const {
    storeFallbackImage,
    offerFallbackImage,
    productCategoryFallbackImage,
    paymentIcons,
    socialMediaIcons,
    storeDetailCampaign
  } = content;
  return {
    storeFallbackImage: {
      url: storeFallbackImage?.url ?? void 0,
      width: storeFallbackImage?.original?.width ?? void 0,
      height: storeFallbackImage?.original?.height ?? void 0,
      description: storeFallbackImage?.description ?? void 0
    },
    offerFallbackImage: offerFallbackImage?.url,
    productCategoryFallbackImage: productCategoryFallbackImage?.url,
    productCategories,
    paymentIcons,
    socialMediaIcons,
    campaignBanner: {
      description: campaignBanner?.description,
      url: campaignBanner?.url,
      startDate: storeDetailCampaign?.startEndDate?.startDate,
      endDate: storeDetailCampaign?.startEndDate?.endDate,
      storesList: storeDetailCampaign?.storesList
    }
  };
};
export {
  useBloomreachSdpContent
};
//# sourceMappingURL=use-bloomreach-sdp-content.js.map
